import React from "react";
import ausbg from "../assets/img/singaporebg.jpg";
import ausflag from "../assets/flags/singapore.jpg";
import Singacomponent from "./Singacomponent";

export default function Singapage() {
  return (
    <>
      {/* hero section start */}
      <div id="#customcontainer" className="customcontainer mt-4 pt-3">
        <div
          className="bg-image d-flex justify-content-center mt-5 align-items-center"
          style={{
            backgroundImage: `url(${ausbg})`,
            height: "500px",
            backgroundSize: "cover",
            backgroundPosition: "top",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            backgroundBlendMode: "overlay",
          }}
        >
          <div className="row landingformlayout w-100 mx-0 px-5 mt-5">
            <div className="col-md-8 ieltslandingcontent">
              <h1 className="bannerHeading text-light">
                Why Study In Singapore ?
              </h1>
              <ul className="bannerPoints text-dark">
                <li className="my-3 ullist text-light">
                  <i className="fa fa-check-circle"></i> Worldwide recognition
                  for outstanding academic achievements
                </li>
                <li className="my-3 ullist text-light">
                  <i className="fa fa-check-circle"></i> A diverse and
                  multicultural populace
                </li>
                <li className="my-3 ullist text-light">
                  <i className="fa fa-check-circle"></i> Students get utmost
                  learning opportunities.
                </li>
                <li className="my-3 ullist text-light">
                  <i className="fa fa-check-circle"></i> Exceptional living
                  standards
                </li>
                <li className="my-3 ullist text-light">
                  <i className="fa fa-check-circle"></i> An environment
                  characterized by safety and security
                </li>
                <li className="my-3 ullist text-light">
                  <i className="fa fa-check-circle"></i> Top-notch educational
                  offerings
                </li>
              </ul>
              <img
                src={ausflag}
                className="mt-2 mx-4"
                style={{ width: "80px" }}
              />
            </div>

            <div
              className="ieltslandingcontentmobile"
              style={{ display: "none" }}
            >
              <h1 className="bannerHeading text-light">
                Why to Study in Singapore ?
              </h1>
            </div>
          </div>
        </div>
      </div>
      {/* hero section ended */}

      <div className="container">
        <div className="section-head col-sm-12 mb-1 mt-3">
          <h4>
            <span>Singapore</span>
          </h4>
        </div>
        <Singacomponent />
      </div>
    </>
  );
}
